/**
 *
 */
export enum FacilitiesUsage {
  Shared = 1,
  Own = 2,
  None = 3,
}
